<template>
  <div :style="{'text-align':'center'}">
    <!-- 表单 -->
    <div>
      <!-- 表单-商品选择-二级商品类型 + 已选择部分 -->
      <md-table class="select-table" :style="{'text-align':'left'}" @md-selected="table_selectCloud" :md-selected-value.sync="form" v-model="table_goods">
        <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="multiple" md-auto-select>
              <md-table-cell :md-label="$I18n('good_name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('company_name')">{{ item.comp_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('effect_month')">{{ item.month }}</md-table-cell>
              <md-table-cell :md-label="$I18n('cost')">
                <p :style="{'margin': 0}">¥{{ item.comp_cn_price }}</p>
                <p :style="{'margin': 0}">¥{{ item.comp_other_price }}</p>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('fact_fee')">
                <p :style="{'margin': 0}">¥{{ item.rmb_fact_price }}</p>
                <p :style="{'margin': 0}">${{ item.usd_fact_price }}</p>
                <p :style="{'margin': 0}">{{$I18n("money_type_22")}}{{ item.inr_fact_price }}</p>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('only_buy_1')">{{ item.only == 2 ?$I18n("close") :$I18n("open") }}</md-table-cell>
        </md-table-row>
        <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
      </md-table>
      <!-- 翻页 -->
      <table-page :total="total" :pageSize="pageSize" v-model="pageNo"/>
    </div>
    <md-button class="md-info right-button" @click="form_submit">{{$I18n("sure")}}</md-button>

    <!-- 弹窗 -->
    <modal v-show="modal" @close="modal_closeModal" class="lg-modal">
      <template slot="header">
        <h4 class="modal-title">{{$I18n("tips")}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_closeModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <div>{{$I18n("is_sure_edit")}}</div>
      </template>

      <!-- 弹窗按钮 -->
      <template slot="footer">
        <md-button @click="modal_submit" class="left-icon md-info">{{$I18n("sure")}}</md-button>
        <md-button @click="modal_closeModal" class="">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Modal } from '@/components';
export default {
  components: {
    Modal,
  },
  props: {
    pk : {
      type: String,
      default: "",
    },
    show : {
      type: Boolean,
      default: false,
    },
    comps: {
      type: Array,
      default: () => [],
    }
  },
  data(){
    return {
      typeData: [],
      // 表格选中的商品
      form  : [],        // 表格选中的商品
      goods : [],     // 所有的商品的数据列表

      selectAll : false,
      modal : false,

      pageSize: 10,
      pageNo : 1,
      total  : 0,
    }
  },
  computed:{
    // 非全选时状态
    isIndeterminate() {
      const checkedLength = this.form.main.length;
      return checkedLength > 0 && checkedLength < this.goodShow.length;
    },
    table_goods() {
      return [...this.goods].slice((this.pageNo - 1) * this.pageSize, this.pageNo * this.pageSize);
    },
  },
  watch:{
  },
  methods: {
    table_selectCloud (item){ // 表格-选择云存储
      this.form = item;
    },
    form_submit (){
      this.modal = true;
    },
    modal_closeModal(){
      this.modal = false;
    },
    // 提交 商品配置
    modal_submit(){
      this.$api.setAppProduct({
        ids: this.form.map(i => i.id),
        pk : this.pk,
        link_type: 1,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.modal_closeModal();
          this.api_getGoodSet();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    api_getType (){
      return  this.$api.getGoodClass({ })
        .then(this.$Then(res => {
          this.typeData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.typeData = [];
        }))
    },
    // 获取对应APP的商品列表
    api_getGoodSet(){
      this.form = [];
      return this.$api.getBindGood({
        "pk"         : this.pk,
        "link_type"  : 1,
        "page_no"    : 1,
        "page_size"  : 9999,
      })
        .then(this.$Then(res => {
          let ids = res.data.map(i => {
            return i.link_id
          })
          this.form =  this.goods.filter(good => {
            return ids.includes(good.id)
          })
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },

    // 获取所有的Good
    api_getAllGood(){
      return this.$api.getGood({
        "seller_id"  :"",
        "app_id"     : "",
        "category_id":0,
        "page_index" :1,
        "page_size"  :9999,
      })
        .then(this.$Then(res => {
          this.total = res.count;
          this.goods = res.data.map(item => {
            let type_name = "";
            let typeInfo = this.typeData.filter(type => {
              return type.id === item.category_id
            })
            if(typeInfo.length > 0){
              type_name = typeInfo[0].name
            }

            let comp_name = "";
            let compInfo = this.comps.filter(comp => {
              return comp.comp_id === item.comp_id;
            })
            if(compInfo.length > 0){
              comp_name = compInfo[0].comp_name
            }
            return {
              ...item,
              type_name,
              comp_name,
            }
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
  },
  created(){
    this.api_getType()
      .then(() => {
        return this.api_getAllGood()
      })
      .then(() => {
        if(this.pk){
          this.api_getGoodSet()
        }
      })
  },
}
</script>
<style lang="scss" scoped>
  .left-transfer-item{
    margin-right : 24px;
  }
  .left-transfer-item,
  .right-transfer-item{
    text-align: left;
    display: inline-block;
  }
  .right-button{
    float: right;
  }
</style>